export const WhatsappSupportButton = () => {
  return (
    <div className="flex items-center cursor-pointer hover:scale-105 transition-all duration-300 hover:bg-off-white gap-x-2 border px-2 rounded-lg border-stroke py-2">
      <img
        src={"/assets/icons/whatsapp-icon.svg"}
        alt="WhatsApp"
        className="w-6 h-6"
      />
      <p className="text-medium-dark-grey font-medium font-clash-display text-[14px]">
        Support
      </p>
    </div>
  );
};
